module.exports = __webpack_public_path__ + "img/team-paula-riveros-bitton.3c513637.jpg";